import { render, staticRenderFns } from "./RxConfirm.vue?vue&type=template&id=4d0be2a0"
import script from "./RxConfirm.vue?vue&type=script&lang=js"
export * from "./RxConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports